// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-preview-jsx": () => import("./../../../src/pages/preview.jsx" /* webpackChunkName: "component---src-pages-preview-jsx" */),
  "component---src-pages-unpublished-preview-jsx": () => import("./../../../src/pages/unpublished-preview.jsx" /* webpackChunkName: "component---src-pages-unpublished-preview-jsx" */),
  "component---src-templates-news-template-jsx": () => import("./../../../src/templates/newsTemplate.jsx" /* webpackChunkName: "component---src-templates-news-template-jsx" */),
  "component---src-templates-page-template-jsx": () => import("./../../../src/templates/pageTemplate.jsx" /* webpackChunkName: "component---src-templates-page-template-jsx" */)
}

